import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { Facility } from '../models/facility.model';

@Injectable()
export class FacilityService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/Facility/";
    }

    async getFacilities(): Promise<Facility[]> {
        return await this._http.get<Facility[]>(`${this.apiServer}GetFacilities`).toPromise<Facility[]>();
    }

    async getFacilitiesInfiniteScroll(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string): Promise<Facility[]> {
        const params = new HttpParams()
            .set('mostRecent', mostRecent.toString())
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction);

        return await this._http.get<Facility[]>(`${this.apiServer}GetFacilitiesInfiniteScroll`, { params: params }).toPromise<Facility[]>();
    }

    async getFacilityByAcronym(acronym: string): Promise<Facility> {
        const params = new HttpParams()
            .set('acronym', acronym);

        return await this._http.get<Facility>(`${this.apiServer}GetFacilityByAcronym`, { params: params}).toPromise<Facility>();
    }

    async getFacilityByName(name: string): Promise<Facility> {
        const params = new HttpParams()
            .set('name', name);

        return await this._http.get<Facility>(`${this.apiServer}GetFacilityByName`, { params: params}).toPromise<Facility>();
    }

    async removeFacility(id: number): Promise<boolean> {
        const params = new HttpParams()
            .set('id', id.toString());

        return await this._http.delete<boolean>(`${this.apiServer}RemoveFacility`, { params: params }).toPromise<boolean>();
    }    

    async setFacility(facility: Facility): Promise<number> {            
        return await this._http.post<number>(`${this.apiServer}SetFacility`, JSON.stringify(facility)).toPromise<number>();
    }
}